module.exports = new __parcel__URL__("add-on-v2-darkmode.304b5bcc.svg").toString();